import { render, staticRenderFns } from "./PurchaseProduct.vue?vue&type=template&id=e01f2728&scoped=true"
import script from "./PurchaseProduct.vue?vue&type=script&lang=js"
export * from "./PurchaseProduct.vue?vue&type=script&lang=js"
import style0 from "./PurchaseProduct.vue?vue&type=style&index=0&id=e01f2728&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01f2728",
  null
  
)

export default component.exports